import styled from "styled-components";

const MonthlyTableWrapper = styled.div`
  th {
    display: none;
  }
  .innerCell th {
    display: table-cell;
  }
  .odd {
    padding: 16px;
    border: 1px solid;
    margin: 10px 0;
  }
  .even {
    padding: 16px;
    border: 1px solid;
    margin: 10px 0;
  }
  .ant-table-tbody > tr > td {
    padding: 0;
  }
  .borderedSection {
    background: #ffffff;
  }
`;

export default MonthlyTableWrapper;
